import React, { useRef } from 'react';
import { CmsSsrComponentProps, ISize } from '@/types/cms';
import Container from './Container';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import useTranslation from 'next-translate/useTranslation';

const FONT_SIZE_CLASSES = {
  [ISize.small]: 'enki-body-xs',
  [ISize.middle]: 'enki-body-base',
  [ISize.large]: 'enki-body-xl'
} as const;

const Text: React.FC<CmsSsrComponentProps> = props => {
  const { componentKey, componentInstanceKey, properties, top } = props;
  const { t } = useTranslation('common');
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  return (
    <Container
      componentKey={componentKey}
      componentInstanceKey={componentInstanceKey}
      properties={properties}
      className="px-3"
      top={top}>
      <div
        style={{
          fontWeight: properties?.font_weight as any,
          color: properties?.color
        }}
        className={twMerge(
          classNames('relative tracking-[0.38px] mx-0 my-2.5', FONT_SIZE_CLASSES[properties.font_size as ISize])
        )}>
        {properties?.text && properties?.text?.includes('\n') ? (
          <div
            className="text-ellipsis overflow-hidden"
            style={{ WebkitBoxOrient: 'vertical', display: '-webkit-box' }}>
            <span dangerouslySetInnerHTML={{ __html: properties?.text?.replace(/\n/g, '<br />') }}></span>
          </div>
        ) : (
          <div
            ref={containerRef}
            style={{
              WebkitBoxOrient: 'vertical',
              display: '-webkit-box',
              color: `${properties?.color}`,
              textAlign: properties?.align as any,
              fontStyle: properties?.italic
            }}
            className="text-ellipsis overflow-hidden">
            <span ref={contentRef}>{properties?.text}</span>
          </div>
        )}
      </div>
    </Container>
  );
};

export default Text;
